






















import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
export default {
  name: 'MStoreCardPanel',
  props: {
    title: {
      type: String
    },
    icon: {
      type: String
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    LoadingSpinner
  }
};
